<template>
	<div>
    <button
      class="button is-info"
      :class="{ 'is-loading': loading }"
      v-if="loading == true"
    >e</button>
		<pdf
			:src="pageURL.pdfURL"
			@num-pages="pageCount = $event"
			@page-loaded="currentPage = $event, loading = false, assign()"
      :page=currentPage
		></pdf>
        <div class="navbar">
          <div class="navbar-item">
            <button @click="addBliss()"><img src="../assets/bliss.png">{{this.bliss}}</button>
          </div>
          <div class="navbar-item">
            <button @click="addFedUp()"><img src="../assets/fedUp.png">{{this.fedUp}}</button>
          </div>
          <div class="navbar-item">
            <button @click="addOooh()"><img src="../assets/oooh.png">{{this.oooh}}</button>
          </div>
          <div class="navbar-item">
            <button @click="addDead()"><img src="../assets/dead.png">{{this.dead}}</button>
          </div>
          <div class="navbar-item">
            <button @click="addCry()"><img src="../assets/cry.png">{{this.cry}}</button>
          </div>
        </div>
      <input v-model="currentPage" @keyup="manChange" @click="manChange" type="number"> / {{pageCount}}
    <div class="columns">
      <div class="column">
        <button id="prev" @click="prev">Previous</button>
      </div>
      <div class="column">
        <button id="next" @click="next">Next</button>
      </div>     
    </div>    
	</div>
</template>

<script>

import pdf from 'vue-pdf'
import { db } from '../firebase'

export default {
	components: {
		pdf
	},
	data() {
		return {
      pageCount: 0,
      loading: true,
      bliss: 0,
      fedUp: 0,
      oooh: 0,
      dead: 0,
      cry: 0,
      totals: [],
      thing: this.currentPage,
      voteReg: null
		}
  },
  computed: {
    expressions(){
      return db.doc(`chats/${this.chatId}/metaData/expressions/totals/${this.currentPage}`);
    },
    expressionsU(){
      return db.doc(`chats/${this.chatId}/metaData/expressions`).collection('totals');
    },
    cupo(){
      let i = this.currentPage - 1;
      return i;
    },
    voteVerify(){
      return db.doc(`users/${this.yourId}/votes/${this.chatId}`).collection('emotes');
    }

  },
  firestore() {
    return {
      totals: this.expressionsU.orderBy('page'),
      thing: this.expressions,
      voteReg: this.voteVerify
    };
  },
  methods: {
     assign(){
        this.bliss = this.totals[this.cupo].bliss,
        this.fedUp = this.totals[this.cupo].fedUp,
        this.oooh = this.totals[this.cupo].oooh,
        this.dead = this.totals[this.cupo].dead,
        this.cry = this.totals[this.cupo].cry
      // this.expressions.get().then(function(doc) {
      //     if (doc.exists) {
      //         this.bliss = this.totals[this.cupo].bliss,
      //         this.fedUp = this.totals[this.cupo].fedUp,
      //         this.oooh = this.totals[this.cupo].oooh,
      //         this.dead = this.totals[this.cupo].dead,
      //         this.cry = this.totals[this.cupo].cry,
      //         console.log("Document data:", doc.data());
      //     } else {
      //         // doc.data() will be undefined in this case
      //         this.bliss = 0,
      //         this.fedUp = 0,
      //         this.oooh = 0,
      //         this.dead = 0,
      //         this.cry = 0,
      //         console.log("No such document!");
      //     }
      // }).catch(function(error) {
      //     console.log("Error getting document:", error);
      // });
     },
    next(){
      if(this.currentPage < this.pageCount){
        this.currentPage++;
        this.assign();
        this.$emit('update:currentPage', this.currentPage);
        this.$emit('pageChange');
      }
    },
    prev(){
      if(this.currentPage > 1){
        this.currentPage--;
        this.assign();
        this.$emit('update:currentPage', this.currentPage);
        this.$emit('pageChange');
      }
    },
    manChange(){
      this.next();
      this.prev();
    },
    async addBliss(){
      if(this.voteReg.find(reg => reg.page === this.currentPage) === undefined){
        await this.voteVerify.doc(`${this.currentPage}`).set({
          emote: 'bliss',
          createdAt: Date.now(),
          page: this.currentPage
        });
        this.expressions.update({
          bliss: this.bliss += 1
        });
      }
      else if(this.voteReg.find(reg => reg.page === this.currentPage).emote !== 'bliss'){
        let bookMark = this.voteReg.find(reg => reg.page === this.currentPage).emote;
        await this.voteVerify.doc(`${this.currentPage}`).set({
          emote: 'bliss',
          createdAt: Date.now(),
          page: this.currentPage
        });
        this.expressions.update({
          bliss: this.bliss += 1
        })
        switch (bookMark) {
          case 'fedUp':
            this.expressions.update({
              fedUp: this.fedUp -= 1
            });
            break;
          case 'oooh':
            this.expressions.update({
              oooh: this.oooh -= 1
            });
            break;
          case 'dead':
            this.expressions.update({
              dead: this.dead -= 1
            });
            break;
          case 'cry':
            this.expressions.update({
              cry: this.cry -= 1
            });
            break;
        }
      }     
    },
    async addFedUp(){
      if(this.voteReg.find(reg => reg.page === this.currentPage) === undefined){
        await this.voteVerify.doc(`${this.currentPage}`).set({
          emote: 'fedUp',
          createdAt: Date.now(),
          page: this.currentPage
        });
        this.expressions.update({
          fedUp: this.fedUp += 1
        });
      }
      else if(this.voteReg.find(reg => reg.page === this.currentPage).emote !== 'fedUp'){
        let bookMark = this.voteReg.find(reg => reg.page === this.currentPage).emote;
        await this.voteVerify.doc(`${this.currentPage}`).set({
          emote: 'fedUp',
          createdAt: Date.now(),
          page: this.currentPage
        });
        this.expressions.update({
          fedUp: this.fedUp += 1
        });
        switch (bookMark) {
          case 'bliss':
            this.expressions.update({
              bliss: this.bliss -= 1
            });
            break;
          case 'oooh':
            this.expressions.update({
              oooh: this.oooh -= 1
            });
            break;
          case 'dead':
            this.expressions.update({
              dead: this.dead -= 1
            });
            break;
          case 'cry':
            this.expressions.update({
              cry: this.cry -= 1
            });
            break;
        }
      }    
    },
    async addOooh(){
      if(this.voteReg.find(reg => reg.page === this.currentPage) === undefined){
        await this.voteVerify.doc(`${this.currentPage}`).set({
          emote: 'oooh',
          createdAt: Date.now(),
          page: this.currentPage
        });
        this.expressions.update({
          oooh: this.oooh += 1
        });
      }
      else if(this.voteReg.find(reg => reg.page === this.currentPage).emote !== 'oooh'){
        let bookMark = this.voteReg.find(reg => reg.page === this.currentPage).emote;
        await this.voteVerify.doc(`${this.currentPage}`).set({
          emote: 'oooh',
          createdAt: Date.now(),
          page: this.currentPage
        });
        this.expressions.update({
          oooh: this.oooh += 1
        })
        switch (bookMark) {
          case 'fedUp':
            this.expressions.update({
              fedUp: this.fedUp -= 1
            });
            break;
          case 'bliss':
            this.expressions.update({
              bliss: this.bliss -= 1
            });
            break;
          case 'dead':
            this.expressions.update({
              dead: this.dead -= 1
            });
            break;
          case 'cry':
            this.expressions.update({
              cry: this.cry -= 1
            });
            break;
        }
      }
    },
    async addDead(){
      if(this.voteReg.find(reg => reg.page === this.currentPage) === undefined){
        await this.voteVerify.doc(`${this.currentPage}`).set({
          emote: 'dead',
          createdAt: Date.now(),
          page: this.currentPage
        });
        this.expressions.update({
          dead: this.dead += 1
        });
      }
      else if(this.voteReg.find(reg => reg.page === this.currentPage).emote !== 'dead'){
        let bookMark = this.voteReg.find(reg => reg.page === this.currentPage).emote;
        await this.voteVerify.doc(`${this.currentPage}`).set({
          emote: 'dead',
          createdAt: Date.now(),
          page: this.currentPage
        });
        this.expressions.update({
          dead: this.dead += 1
        })
        switch (bookMark) {
          case 'fedUp':
            this.expressions.update({
              fedUp: this.fedUp -= 1
            });
            break;
          case 'oooh':
            this.expressions.update({
              oooh: this.oooh -= 1
            });
            break;
          case 'bliss':
            this.expressions.update({
              bliss: this.bliss -= 1
            });
            break;
          case 'cry':
            this.expressions.update({
              cry: this.cry -= 1
            });
            break;
        }
      }

    },
    async addCry(){
      if(this.voteReg.find(reg => reg.page === this.currentPage) === undefined){
        await this.voteVerify.doc(`${this.currentPage}`).set({
          emote: 'cry',
          createdAt: Date.now(),
          page: this.currentPage
        });
        this.expressions.update({
          cry: this.cry += 1
        });
      }
      else if(this.voteReg.find(reg => reg.page === this.currentPage).emote !== 'cry'){
        let bookMark = this.voteReg.find(reg => reg.page === this.currentPage).emote;
        await this.voteVerify.doc(`${this.currentPage}`).set({
          emote: 'cry',
          createdAt: Date.now(),
          page: this.currentPage
        });
        this.expressions.update({
          cry: this.cry += 1
        })
        switch (bookMark) {
          case 'fedUp':
            this.expressions.update({
              fedUp: this.fedUp -= 1
            });
            break;
          case 'oooh':
            this.expressions.update({
              oooh: this.oooh -= 1
            });
            break;
          case 'dead':
            this.expressions.update({
              dead: this.dead -= 1
            });
            break;
          case 'bliss':
            this.expressions.update({
              bliss: this.bliss -= 1
            });
            break;
        }
      }
      
    }
  },
  props: ['pageURL', 'chatId', 'currentPage', 'yourId']
}

</script>

<style>

</style>